export const saveArticleEvent = (aticle_id: string, action_type: string) => {
    const evtVal = {
        control_fields: {
            mparticle: {
                keys: {
                    action_type: 'action_type',
                    article_id: 'article_id',
                    context: 'context'
                }
            }
        },
        event_name: 'on_page_action_click',
        action_type: action_type,
        article_id: aticle_id,
        context: 'saved_for_later'
    }
    const customEvent = new CustomEvent('custom-event', {
        detail: evtVal
    })
    document.dispatchEvent(customEvent)
}

export const clickCtaEvent = (link: HTMLAnchorElement) => {
    const evtVal = {
        control_fields: {
            mparticle: {
                keys: {
                    anchor_text: 'anchor_text',
                    click_source_type: 'click_source_type',
                    layout_section: 'layout_section',
                    target_url: 'target_url'
                },
                mp_event_type: 'Navigation'
            }
        },
        anchor_text: link.innerText,
        click_source_type: 'link',
        event_name: 'click',
        layout_section: 'bookmark-tool-tip',
        target_url: link.href
    }
    const customEvent = new CustomEvent('custom-event', {
        detail: evtVal
    })
    document.dispatchEvent(customEvent)
}
